import React from "react";
import { Col, Form, Input, Row, Select } from "antd";
const { Option } = Select;

export function AddressInformation({ getFieldDecorator, selectDataForFixedSelectList, fixedList, userData }) {
    const { country, district, residence, parish, street, postalCode3, postalCode4, door, piso } = userData;
    return (
        <Form layout="vertical">
            <Row gutter={16}>
                <Col xs={24} md={8}>
                    <Form.Item label="País">
                        {getFieldDecorator("idpais", {
                            initialValue: country,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                onChange={(pais) =>
                                    selectDataForFixedSelectList(
                                        {
                                            query: "distrito",
                                            pais: pais,
                                        },
                                        "distrito"
                                    )
                                }
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {fixedList.pais !== undefined &&
                                    fixedList.pais.data.map((item) => {
                                        return (
                                            <Option key={item.idpais} value={item.idpais}>
                                                {item.designacao}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Distrito">
                        {getFieldDecorator("distrito", {
                            initialValue: district,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                onChange={(distrito) =>
                                    selectDataForFixedSelectList(
                                        {
                                            query: "concelho",
                                            distrito: distrito,
                                        },
                                        "concelho"
                                    )
                                }
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {fixedList.distrito !== undefined &&
                                    fixedList.distrito.data.map((item) => {
                                        return (
                                            <Option key={item.id_dist_ilhas} value={item.id_dist_ilhas}>
                                                {item.descricao}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Concelho">
                        {getFieldDecorator("id_distconc", {
                            initialValue: residence,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                onChange={(id_distconc) =>
                                    selectDataForFixedSelectList(
                                        {
                                            query: "freguesia",
                                            concelho: id_distconc,
                                        },
                                        "freguesia"
                                    )
                                }
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {fixedList.concelho !== undefined &&
                                    fixedList.concelho.data.map((item) => {
                                        return (
                                            <Option key={item.id_distconc} value={item.id_distconc}>
                                                {item.descricao}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Freguesia">
                        {getFieldDecorator("id_freguesia", {
                            initialValue: parish,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {fixedList.freguesia !== undefined &&
                                    fixedList.freguesia.data.map((item) => {
                                        return (
                                            <Option key={item.id_freguesia} value={item.id_freguesia}>
                                                {item.descricao}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Arruamento">
                        {getFieldDecorator("arruamento", {
                            initialValue: street,
                        })(<Input />)}
                    </Form.Item>
                </Col>
                <Col xs={24} md={postalCode3 ? 4 : 8}>
                    <Form.Item label="Código postal">
                        {getFieldDecorator("c_postal4", {
                            initialValue: postalCode4,
                        })(<Input placeholder="Código postal" />)}
                    </Form.Item>
                </Col>
                {postalCode3 && (
                    <Col xs={24} md={4}>
                        <Form.Item label=":">
                            {getFieldDecorator("c_postal3", {
                                initialValue: postalCode3,
                            })(<Input placeholder="Código postal" />)}
                        </Form.Item>
                    </Col>
                )}
                <Col xs={24} md={8}>
                    <Form.Item label="Porta">
                        {getFieldDecorator("porta", {
                            initialValue: door,
                        })(<Input />)}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                    <Form.Item label="Andar">
                        {getFieldDecorator("andar", {
                            initialValue: piso,
                        })(<Input />)}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}
